module.exports = __webpack_public_path__ + "img/dsci0082.795d1615.jpg";